import * as React from "react";
import { Tag } from "primereact/tag";
import { CatJobHistoryItem } from "../../../client/types.gen";
import { enhancedLabel } from "./types";
import styles from "./CatCard.module.css";

// The tags that tell one run of a model apart from another: Active, Enhanced
// (with the roof source), Policy term / Annual, Auto and Test run. Shared by
// the Run History rows and the run picker so a run reads the same in both.
// ``showTermTags``: only worth showing once the model has priced a policy
// term for this report, so the annual companion shadows need telling apart
// from the term runs, and older untagged runs read as what they are.
export const RunTags: React.FC<{
  job: CatJobHistoryItem;
  showTermTags: boolean;
}> = ({ job, showTermTags }) => (
  <>
    {job.is_active && (
      <Tag value="Active" severity="success" className={styles.modelTag} />
    )}
    {job.enriched && (
      <Tag
        value={
          job.enrichment_source
            ? enhancedLabel(job.enrichment_source)
            : "Enhanced"
        }
        severity="info"
        className={styles.modelTag}
      />
    )}
    {showTermTags && job.term !== null && (
      <Tag
        value={job.term === "policy" ? "Policy term" : "Annual"}
        severity={job.term === "policy" ? "warning" : null}
        className={styles.modelTag}
      />
    )}
    {/* Clearance auto-runs are suppressed on the Modeling tab itself, so the
        tag is the only place they are named — without it they read as a run
        someone started by hand. */}
    {job.auto_run && (
      <Tag value="Auto" className={`${styles.modelTag} ${styles.autoTag}`} />
    )}
    {/* An engineer's Shadow-run-button run: never offered by the Layers
        tab's vendor data dialog, so say so wherever the run is listed. */}
    {job.run_type === "test_run" && (
      <Tag value="Test run" severity="warning" className={styles.modelTag} />
    )}
  </>
);

/** Whether a model's history warrants Policy term / Annual tags. */
export const hasPolicyTermRun = (jobs: CatJobHistoryItem[]): boolean =>
  jobs.some((job) => job.term === "policy");
